var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1060.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1080,976.17l-353.76-369.15c39.41-61.4,62.56-134.23,62.56-212.61C788.8,176.59,612.22,0,394.4,0S0,176.59,0,394.41s176.57,394.39,394.4,394.39c95.3,0,182.71-33.81,250.89-90.07l346.72,361.8,87.99-84.36ZM394.4,666.96c-150.29,0-272.56-122.27-272.56-272.55S244.11,121.84,394.4,121.84s272.56,122.27,272.56,272.57-122.27,272.55-272.56,272.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.104cdddc87d9d53a758a048e56d77d22.svg";
export { ForwardRef as ReactComponent };